import { Spark } from "../ui/decor";

const POINTS = [
  "Works with any scale",
  "Snap a photo — AI logs your food",
  "Meal ideas for your budget",
  "Friends & groups keep you going",
  "Rewards showing up",
  "Made for the GLP-1 era",
  "Free, no subscription",
  "No ads, no card needed",
];

/** One pass of the phrase list, with sun sparks between items. */
function Row({ ariaHidden = false }: { ariaHidden?: boolean }) {
  return (
    <div
      aria-hidden={ariaHidden || undefined}
      className="flex shrink-0 items-center"
    >
      {POINTS.map((p, i) => (
        <span key={i} className="flex shrink-0 items-center">
          <span className="whitespace-nowrap px-6 font-display text-lg font-extrabold text-white sm:px-8 sm:text-2xl">
            {p}
          </span>
          <Spark className="h-5 w-5 shrink-0 sm:h-6 sm:w-6" />
        </span>
      ))}
    </div>
  );
}

export function TrustStrip() {
  return (
    <section className="overflow-x-clip py-10 sm:py-14">
      <div className="relative">
        {/* Counter-tilted teal band peeking out behind — pure decoration. */}
        <div
          aria-hidden
          className="absolute left-[-2vw] top-1/2 w-[104vw] -translate-y-1/2 rotate-[1.5deg] rounded-sm bg-teal py-4 sm:py-5"
        >
          <div className="h-7 sm:h-9" />
        </div>

        {/* The ribbon word band. */}
        <div className="relative left-[-2vw] w-[104vw] -rotate-[1.5deg] bg-navy py-4 sm:py-5">
          <div className="flex overflow-hidden">
            <div className="animate-marquee flex shrink-0 items-center">
              <Row />
              <Row ariaHidden />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
